import { MessagePrimaryChannelStatus } from "@bvhi/backend-api";
import { Chip, ChipProps } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props extends ChipProps {
  type: MessagePrimaryChannelStatus;
}

export function PrimaryChanelStatusCell({ type, size = "small", ...chipProps }: Props) {
  const { t } = useTranslation(["enums"]);

  const label = useMemo(() => {
    switch (type) {
      case MessagePrimaryChannelStatus.ACTIVE:
        return t("enums:enums.message.primary.channel.status.active");
      case MessagePrimaryChannelStatus.DELIVERED:
        return t("enums:enums.message.primary.channel.status.delivered");
      case MessagePrimaryChannelStatus.FAILED:
        return t("enums:enums.message.primary.channel.status.failed");
      case MessagePrimaryChannelStatus.STALLED:
        return t("enums:enums.message.primary.channel.status.stalled");
    }
    return "";
  }, [type, t]);

  return <Chip label={label} size={size} {...chipProps} />;
}
